import IconLaneMid from './IconLaneMid';

export default IconLaneMid;